

/**
 * Throws an error with the supplied error message.
 * @param message 
 */
export function fail(message: string): never;
/**
 * Throws the supplied error.
 * @param error Error to be thrown.
 */
export function fail(error: Error): never;
export function fail<T>(arg: string | Error): void
{
    const error = (typeof arg == "string") ? new Error(arg) : arg;
    throw error;
}
